import { useSearchContext } from "../../context/SearchContext";

const AlertWithCloseButton = (props) => {
  const { showModal, handleShowModal, objectProps } = useSearchContext();

  const { status, message } = objectProps;
  return (
    <div
      className="custom-alert-overlay"
      style={{
        position: "fixed",
        zIndex: 2000,
        inset: 0,
        background: "rgba(0,0,0,0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        className={`alert alert-${
          status || "info"
        } alert-dismissible fade show`}
        role="alert"
      >
        <p>{message || "Mensaje Informativo"}</p>
        <button
          type="button"
          className="btn-close"
          data-bs-dismiss="alert"
          aria-label="Cerrar"
          onClick={() => handleShowModal(false)}
        ></button>
      </div>
    </div>
  );
};

export default AlertWithCloseButton;
